import { Fragment, useContext } from 'react'

import { EMPTY_OBJECT } from '../../../../constants/common'
import { FormikWysiwygField } from '../../../Formik'
import { EmailFormContext } from '../../EmailForm.context'
import {
  EMAIL_CREATION_FORM_FIELD_NAME_MESSAGE,
  EMAIL_CREATION_FORM_WYSIWYG_MIN_HEIGHT,
} from '../EmailCreationForm.constants'
import { useFont } from '../EmailCreationForm.hooks'

function MessageField({
  editor,
  fieldsProps = EMPTY_OBJECT,
  linkedFiles,
  onClickFile,
  onDragLeave,
  onDragOver,
  onDrop,
  onFocusEditor,
  onInitEditor,
  onRemoveFileLinksBlock,
}) {
  const { blocked, isDragging } = useContext(EmailFormContext)

  const { font } = useFont({
    editor,
  })

  return (
    <FormikWysiwygField
      {...fieldsProps}
      enableInlineImageAttach
      enableTables
      Field={Fragment}
      blocked={blocked}
      font={font}
      isDragging={isDragging}
      linkedFiles={linkedFiles}
      minHeight={EMAIL_CREATION_FORM_WYSIWYG_MIN_HEIGHT}
      name={EMAIL_CREATION_FORM_FIELD_NAME_MESSAGE}
      onClickFile={onClickFile}
      onDragLeave={onDragLeave}
      onDragOver={onDragOver}
      onDrop={onDrop}
      onFocus={onFocusEditor}
      onInit={onInitEditor}
      onRemoveFileLinksBlock={onRemoveFileLinksBlock}
    />
  )
}

export default MessageField
